import React, { useState } from 'react'
import { IconContext } from 'react-icons';
import { TfiKey } from "react-icons/tfi";
import { FaRegUser } from "react-icons/fa";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"; // אייקונים של עין
import { Link, useNavigate } from 'react-router-dom';
import Cookies from "universal-cookie"
import axiosAuth from '../Api/axiosAuth';
import { useAuth } from '../Context/AuthProvider';
import { isMobileDevice } from '../util/device';
const LOGIN_URL = '/auth/login';

const CardLogin = () => {
    const [infpError, setInfpError] = useState(false);
    const [user, setUser] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false); // משתנה למצב הצגת הסיסמה
    const [showResetPopup, setShowResetPopup] = useState(false);
    const [idNumber, setIdNumber] = useState("");
    const [resetStatus, setResetStatus] = useState(null); // null | { type: 'success', email } | { type: 'error', message }
    const [resetLoading, setResetLoading] = useState(false);
    const [idError, setIdError] = useState("");
    const navigate = useNavigate();
    const cookies = new Cookies();
    const { auth, setAuth } = useAuth();

    const togglePasswordVisibility = () => {
        setShowPassword(prev => !prev);
    };

    const isIsraeliIdValid = (id) => {
        let strId = String(id).trim();
        if (strId.length === 0) return false;
        if (strId.length > 9) return false;
        while (strId.length < 9) strId = "0" + strId;
        let counter = 0;
        for (let i = 0; i < strId.length; i++) {
            let rawVal = Number(strId[i]) * ((i % 2) + 1);
            let actualVal = rawVal > 9 ? (rawVal - 9) : rawVal;
            counter += actualVal;
        }
        return counter % 10 === 0;
    };

    const handlePasswordRecovery = async () => {
        if (!isIsraeliIdValid(idNumber)) {
            setIdError("מספר תעודת הזהות אינו תקין");
            return;
        }
        setIdError("");
        setResetLoading(true);
        try {
            const response = await axiosAuth.post('auth/passwordRecovery', { numberId: idNumber });
            setShowResetPopup(false);
            console.log(response);
            setResetStatus({ type: 'success', email: response?.data ?? '' });
        } catch (err) {
            const message = err?.response?.data?.message || 'אירעה שגיאה, נסה שנית';
            setShowResetPopup(false);
            setResetStatus({ type: 'error', message });
        } finally {
            setResetLoading(false);
        }
    };

    const auth_submit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosAuth.post(LOGIN_URL, {
                'userName': user, 'password': password
            }, { withCredentials: true });

            localStorage.setItem('access_token', response?.data['access_token']);
            cookies.set('isAllow', "1", { path: '/', maxAge: 31536000 }, { httpOnly: true }, { SameSite: "None" });
            cookies.set('role', response?.data['roles'][0], { path: '/', maxAge: 31536000 }, { httpOnly: true }, { SameSite: "None" });

            axiosAuth.defaults.headers.common['Authorization'] = `Bearer ${response?.data['access_token']}`;
            setAuth(response?.data['refersh_token']);
            setPassword('');
            setUser('');
            setInfpError(false);

            const isMobile = isMobileDevice();
            navigate(isMobile ? '/Mobile' : '/');
        } catch (err) {
            setInfpError(true);
        }
    };

    return (
        <form className='bg-white flex flex-col w-[400px] max-sm:w-[80%] border-2 border-solid border-transparent rounded-md mt-10' onSubmit={auth_submit} style={{ direction: "rtl" }}>
            <label className='bg-[#F7F7F7] w-full py-[1rem] text-[22px] font-normal'>התחברות</label>
            <div className='p-8'>
                {infpError && <p className='mt-0 text-red-700'>המשתמש או הסיסמה לא נכונים</p>}

                <div className='flex w-full'>
                    <IconContext.Provider value={{ color: "#555", size: 35 }}>
                        <FaRegUser className='bg-[#eee] border-[1px] rounded-sm border-solid p-2 border-[#ccc]' />
                    </IconContext.Provider>
                    <input
                        className='w-full border-[1px] rounded-sm pr-2 border-solid border-[#ccc]'
                        type="text"
                        placeholder='שם משתמש'
                        onChange={(e) => setUser(e.target.value)}
                        value={user}
                    />
                </div>

                <div className='flex mt-4 relative'>
                    <IconContext.Provider value={{ color: "#555", size: 35 }}>
                        <TfiKey className='bg-[#eee] border-[1px] rounded-sm border-solid p-2 border-[#ccc]' />
                    </IconContext.Provider>
                    
                    <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        autoComplete='off'
                        placeholder='סיסמה'
                        className='w-full border-[1px] rounded-sm pr-2 border-solid border-[#ccc]'
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                    />
                    
                    <button
                        type="button"
                        className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-600"
                        onClick={togglePasswordVisibility}
                    >
                        {showPassword ? <AiOutlineEye size={24} /> : <AiOutlineEyeInvisible size={24} />}
                    </button>
                </div>

                <button className='bg-[#0D406A] w-full text-lg rounded border-[#0a3254] hover:bg-[#07253e] hover:border-[#04121e] p-2 mt-8 text-white'>
                    התחבר
                </button>
                <p className="mt-4 text-center">
  אין לך חשבון?
  <Link to="/signup" className="text-[#0D406A] font-semibold hover:underline ml-1">
    הירשם עכשיו
  </Link>
</p>
                <p className="mt-2 text-center">
                    <button type="button" onClick={() => { setShowResetPopup(true); setIdNumber(""); }} className="text-[#0D406A] font-semibold hover:underline text-sm">
                        שכחתי סיסמה
                    </button>
                </p>
            </div>

            {/* פופאפ שחזור סיסמה */}
            {showResetPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl shadow-2xl w-[360px] overflow-hidden" style={{ direction: 'rtl' }}>
                        <div className="bg-[#0D406A] px-6 py-4">
                            <h2 className="text-white text-[18px] font-semibold text-center tracking-wide">שחזור סיסמה</h2>
                            <p className="text-blue-200 text-xs text-center mt-1">הזן את מספר תעודת הזהות שלך לאיפוס הסיסמה</p>
                        </div>
                        <div className="p-6">
                            <label className="text-sm font-medium text-gray-700 mb-1 block">מספר תעודת זהות</label>
                            <input
                                type="text"
                                placeholder="הכנס מספר ת.ז"
                                className={`w-full border rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:border-transparent transition ${idError ? 'border-red-400 focus:ring-red-300' : 'border-gray-300 focus:ring-[#0D406A]'}`}
                                value={idNumber}
                                onChange={(e) => { setIdNumber(e.target.value); setIdError(""); }}
                            />
                            {idError && (
                                <p className="text-red-500 text-xs mt-1 mb-3">{idError}</p>
                            )}
                            {!idError && <div className="mb-5"></div>}
                            <button
                                type="button"
                                onClick={handlePasswordRecovery}
                                disabled={resetLoading || !idNumber}
                                className="bg-[#0D406A] w-full text-white rounded-lg py-2.5 font-medium hover:bg-[#07253e] transition disabled:opacity-40 disabled:cursor-not-allowed"
                            >
                                {resetLoading ? (
                                    <span className="flex items-center justify-center gap-2">שולח<span className="animate-spin border-2 border-white border-t-transparent rounded-full w-4 h-4 inline-block"></span></span>
                                ) : 'שלח סיסמה'}
                            </button>
                            <button
                                type="button"
                                onClick={() => { setShowResetPopup(false); setIdNumber(""); }}
                                className="w-full mt-3 text-gray-400 text-sm hover:text-gray-600 transition"
                            >
                                ביטול
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* פופאפ תוצאה */}
            {resetStatus && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 backdrop-blur-sm">
                    <div className="bg-white rounded-2xl shadow-2xl w-[360px] overflow-hidden" style={{ direction: 'rtl' }}>
                        {resetStatus.type === 'success' ? (
                            <>
                                <div className="bg-[#0D406A] px-6 py-4">
                                    <div className="flex items-center justify-center gap-2">
                                        <svg className="w-5 h-5 text-green-300" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                        <h2 className="text-white text-[18px] font-semibold text-center tracking-wide">נשלח בהצלחה</h2>
                                    </div>
                                    <p className="text-blue-200 text-xs text-center mt-1">הסיסמה נשלחה לכתובת המייל שלך</p>
                                </div>
                                <div className="p-6">
                                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-4">
                                        <p className="text-xs text-gray-400 mb-1">נשלח לכתובת המייל</p>
                                        <p className="text-[14px] font-bold text-[#0D406A]">{resetStatus.email}</p>
                                    </div>
                                    <p className="text-xs text-gray-400 text-center mb-4">בדוק גם בתיקיית הספאם אם לא קיבלת</p>
                                    <button
                                        type="button"
                                        onClick={() => { setResetStatus(null); setIdNumber(""); }}
                                        className="bg-[#0D406A] w-full text-white rounded-lg py-2.5 font-medium hover:bg-[#07253e] transition"
                                    >
                                        חזרה להתחברות
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="bg-[#0D406A] px-6 py-4">
                                    <div className="flex items-center justify-center gap-2">
                                        <svg className="w-5 h-5 text-red-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
                                        </svg>
                                        <h2 className="text-white text-[18px] font-semibold text-center tracking-wide">שגיאה</h2>
                                    </div>
                                    <p className="text-blue-200 text-xs text-center mt-1">לא הצלחנו לשחזר את הסיסמה</p>
                                </div>
                                <div className="p-6">
                                    <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-5 text-center">
                                        <p className="text-sm text-gray-600 leading-relaxed">{resetStatus.message}</p>
                                    </div>
                                    {/* <button
                                        type="button"
                                        onClick={() => { setResetStatus(null); setIdNumber(""); setShowResetPopup(true); }}
                                        className="bg-[#0D406A] w-full text-white rounded-lg py-2.5 font-medium hover:bg-[#07253e] transition"
                                    >
                                        נסה שנית
                                    </button> */}
                                    <button
                                        type="button"
                                        onClick={() => { setResetStatus(null); setIdNumber(""); }}
                                        className="w-full mt-3 text-gray-400 text-sm hover:text-gray-600 transition"
                                    >
                                        סגור
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </form>
    );
}

export default CardLogin;
